import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 600 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--icon-fill, none)",
      stroke: "currentColor",
      "stroke-width": "50",
      d: "M502.3 62.6C447.5 15.9 366 24.3 315.7 76.2L296 96.5l-19.7-20.3C226.1 24.3 144.5 15.9 89.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z",
      class: "i974500184__icon-heart-fill"
    }, null, -1)
  ])))
}
export default { render: render }